export interface TraceEntry {
    step: string;
    timestamp: string;
    unixTime: number;
    diff: number;
    detail?: string;
}

export const bootMark = (label: string, detail?: string) => {
    // No-op for safety
};

export const getBootTrace = (): TraceEntry[] => {
    return [];
};

export const isBootTraceEnabled = (): boolean => {
    return false;
};

export const formatBootTrace = (): string => {
    return '';
};
